<div class="wrapper">
  <app-banner type="info" *ngIf="deviceErrors?.length > 0 && detailsInDifferentLanguage">
    {{ '+SERVICE_APP.INFO_ERRORS_IN_FOREIGN_LANGUAGE' | translate }}
  </app-banner>
  <mat-form-field
    *ngIf="!hasOnlyEnterErrorCode"
    class="event-type-filter"
    mat-select-height-large
    data-at-event-type-filter
  >
    <mat-label>{{ '+SERVICE_TOOL.SELECT_ERROR_CODES_TITLE' | translate }}</mat-label>
    <mat-select [formControl]="errorCodesForm" multiple fieldTextContentTooltip>
      <mat-select-trigger>
        <div class="selected-option-wrapper">
          <span *ngIf="!!fieldText" class="selected-option-more-indicator">
            {{ fieldText }}
          </span>
        </div>
      </mat-select-trigger>
      <mat-option
        [style.max-width]="'470px'"
        *ngFor="let error of deviceErrors"
        (click)="errorCodeChanged()"
        [value]="error.value"
        gtm="onSelect"
        gtmAction="Error Code"
        gtmCategory="Service Ticket"
        fieldTextContentTooltip
        >{{ error.viewValue | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-checkbox
    data-at-terms-of-use-checkbox
    gtm="onToggle"
    gtmAction="No Error Code"
    gtmCategory="serviceTicket"
    [(ngModel)]="noErrorCodeCheckboxValue"
    (ngModelChange)="onNoErrorCodeCheckboxChange($event)"
  >
    {{ '+SERVICE_TOOL.NO_ERROR_CODE_AVAILABLE_CHECKBOX' | translate }}
  </mat-checkbox>
</div>
